<template>
  <div class="shop-container" style="padding-bottom: 1.3rem;">
    <ph-header>
      <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
    </ph-header>
    <div class="ai-header-box">
      <img src="@/assets/img/ai_recycle_01.png" alt="" srcset="">
      <div class="btn-box">
        <img src="@/assets/img/ai_recycle_02.png" alt="" srcset="">
        <div class="btn" @click="goRecycle"></div>
      </div>
      <img src="@/assets/img/ai_recycle_03.png" alt="" srcset="">
      <img src="@/assets/img/ai_recycle_04.png" alt="" srcset="">
      <img src="@/assets/img/ai_recycle_05.png" alt="" srcset="">
      <!-- <div class="shuoming">
        <img src="@/assets/img/ai_recycle_10.png" alt="" srcset="">
      </div> -->
    </div>
    <!-- foot -->
    <TabBar /> 
  </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import TabBar from '@/components/common/TabBar'

export default {
  name: 'airecycle',
  components: { PhHeader, TabBar },
  data () {
    return {
      channelid: 0,
      emid: 0,
      recover_url : process.env.VUE_APP_RECYCLE_URL,
    }
  },
  computed: {
    token () {
      return this.$store.getters.token
    }
  },
  created() {
    this.channelid = this.$route.query.channel || '';
    this.emid = this.$route.query.em || '';
  },
  methods: {
    goRecycle() {
      if(this.token){
        location.href = this.recover_url+'index?td_channelid='+this.channelid+'&em='+this.emid
      }else{
        this.$router.push({ 
          name: 'login',
          query: {
            channel: this.channelid,
            source: this.emid,
            return_url: window.location.href
          }
         })
        // this.$router.push({ path: '/login?channel='+this.channelid+'&return_url=' + window.location.href })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ai-header-box {
  position: relative;
  img {
    display: block;
    width: 100%;
    border: none;
    outline: none;
  }
  .btn-box {
    position: relative;
    height: 190px;
    img {
      position: absolute;
    }
    .btn {
      position: absolute;
      height: 90px;
      width: 100%;
      top: 0;
    }
  }
  .shuoming {
    position: absolute;
    right: 0;
    top: 110px;
    img {
      width: 48px;
      height: 155px;
    }
  }
}
</style>

